module.exports = __webpack_public_path__ + "img/cloudways-hosting.99e42a01.jpg";